import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getCarrierName } from '../../utils/plain';
import { AIRLINES, BOOKING_CLASS_CLASS_J } from '../../constants';

const createTimeDisplay = (time) => {
  if (!time) {
    return;
  }
  if (time.length === 5) {
    return time;
  }

  return moment(time).format('HH:mm');
};

const ScheduleItem = (props) => {
  const {
    seat,
    disabledFlightNumber,
    departureAirportName,
    departureTime,
    flightName,
    arrivalAirportName,
    arrivalTime,
    seatStatus,
    classJ,
    operationCarrier,
  } = props;

  return (
    <div className="flightSchedule">
      <div className="flightScheduleItem">
        <div className="flightTitle">{departureAirportName}</div>
        <div className="flightTime">{createTimeDisplay(departureTime)}</div>
      </div>
      <div className="flightScheduleItem">
        <div className="bar"></div>
        {!disabledFlightNumber && (
          <React.Fragment>
            <div className="flightNumber" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {flightName}
              {classJ && <img src="/dp-air/img/logo/jclass.png" alt="" style={{ height: 20, marginLeft: 5 }} />}
            </div>
            {operationCarrier && (
              <div>{operationCarrier}運航</div>
            )}
          </React.Fragment>
        )}
        {seat && (
          <div className="flightSheet isSP">
            <div className="flightTitle">
              空席
              {(seatStatus === 'Vacant') ? '○' : '×'}
            </div>
          </div>
        )}
      </div>
      <div className="flightScheduleItem">
        <div className="flightTitle">{arrivalAirportName}</div>
        <div className="flightTime">{createTimeDisplay(arrivalTime)}</div>
      </div>
      {seat && (
        <div className="flightSheet isPC">
          <div className="flightTitle">
            空席
            {(seatStatus === 'Vacant') ? '○' : '×'}
          </div>
        </div>
      )}
    </div>
  );
};

ScheduleItem.propTypes = {
  seat: PropTypes.bool,
  disabledFlightNumber: PropTypes.bool,
  departureAirportName: PropTypes.string,
  departureTime: PropTypes.string,
  flightName: PropTypes.string,
  arrivalAirportName: PropTypes.string,
  arrivalTime: PropTypes.string,
  seatStatus: PropTypes.string,
  classJ: PropTypes.bool,
  operationCarrier: PropTypes.string,
};

const Flight = (props) => {
  const { seat, disabledFlightNumber, flight } = props;
  const haveConnectingFlights = !!(flight && flight.connectingFlights && flight.connectingFlights.length > 1);

  return (
    <div className={haveConnectingFlights ? 'flightsContainer' : 'flightContainer'}>
      {haveConnectingFlights ? (
        <React.Fragment>
          <ScheduleItem
            seat={seat}
            disabledFlightNumber={disabledFlightNumber}
            departureAirportName={flight.connectingFlights[0].departureAirportName}
            departureTime={flight.connectingFlights[0].departureTime}
            flightName={`${getCarrierName(flight.connectingFlights[0])}${String(flight.connectingFlights[0].flightID || flight.connectingFlights[0].id || '').padStart(3, '0')}`}
            arrivalAirportName={flight.connectingFlights[0].arrivalAirportName}
            arrivalTime={flight.connectingFlights[0].arrivalTime}
            seatStatus={flight.connectingFlights[0].seatStatus}
            classJ={flight.connectingFlights[0].airline === AIRLINES.jal && flight.connectingFlights[0].bookingClass === BOOKING_CLASS_CLASS_J}
            operationCarrier={flight.connectingFlights[0].operationCarrier}
          />
          <div className="flightScheduleSup">{flight.connectingFlights[0].arrivalAirportName} 乗り継ぎ</div>
          <ScheduleItem
            seat={seat}
            disabledFlightNumber={disabledFlightNumber}
            departureAirportName={flight.connectingFlights[1].departureAirportName}
            departureTime={flight.connectingFlights[1].departureTime}
            flightName={`${getCarrierName(flight.connectingFlights[1])}${String(flight.connectingFlights[1].flightID || flight.connectingFlights[1].id || '').padStart(3, '0')}`}
            arrivalAirportName={flight.connectingFlights[1].arrivalAirportName}
            arrivalTime={flight.connectingFlights[1].arrivalTime}
            seatStatus={flight.connectingFlights[1].seatStatus}
            classJ={flight.connectingFlights[1].airline === AIRLINES.jal && flight.connectingFlights[1].bookingClass === BOOKING_CLASS_CLASS_J}
            operationCarrier={flight.connectingFlights[1].operationCarrier}
          />
        </React.Fragment>
      ) : (
        <ScheduleItem
          seat={seat}
          disabledFlightNumber={disabledFlightNumber}
          departureAirportName={flight && flight.departureAirportName}
          departureTime={flight && flight.departureTime}
          flightName={flight ? `${getCarrierName(flight)}${String(flight.flightID || flight.id || '').padStart(3, '0')}` : undefined}
          arrivalAirportName={flight && flight.arrivalAirportName}
          arrivalTime={flight && flight.arrivalTime}
          seatStatus={flight && flight.seatStatus}
          classJ={flight && flight.airline === AIRLINES.jal && flight.bookingClass === BOOKING_CLASS_CLASS_J}
          operationCarrier={flight && flight.operationCarrier}
        />
      )}
    </div>
  );
};

Flight.defaultProps = {
  seat: true,
  disabledFlightNumber: false,
};

Flight.propTypes = {
  seat: PropTypes.bool,
  disabledFlightNumber: PropTypes.bool,
  flight: PropTypes.object,
  sessionFlight: PropTypes.bool,
};

export default Flight;
